"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = exports.getIconSrc = exports.NOTIFICATION_STATUSES = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const icons_1 = require("../icons");
const Spinner_1 = require("../Spinner");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const types_1 = require("./types");
exports.NOTIFICATION_STATUSES = {
    [types_1.NOTIFICATION_STATUS.ok]: 'success',
    [types_1.NOTIFICATION_STATUS.warning]: 'warning',
    [types_1.NOTIFICATION_STATUS.info]: 'info',
    [types_1.NOTIFICATION_STATUS.error]: 'error',
    [types_1.NOTIFICATION_STATUS.loading]: 'loading'
};
const getIconSrc = (status) => {
    let icon = '';
    if (status === types_1.NOTIFICATION_STATUS.error) {
        icon = react_1.default.createElement(icons_1.ErrorStatusIcon, null);
    }
    if (status === types_1.NOTIFICATION_STATUS.ok) {
        icon = react_1.default.createElement(icons_1.SuccessStatusIcon, null);
    }
    if (status === types_1.NOTIFICATION_STATUS.info) {
        icon = react_1.default.createElement(icons_1.InfoStatusIcon, null);
    }
    if (status === types_1.NOTIFICATION_STATUS.warning) {
        icon = react_1.default.createElement(icons_1.WarningStatusIcon, null);
    }
    return icon;
};
exports.getIconSrc = getIconSrc;
const StyledStackView = (0, styled_components_1.default)(StackView_1.StackView) `
    display: inline-flex;
    padding: ${helpers_1.SPACING_S};
    background-color: ${({ theme }) => theme.colorHighlightNotification};
`;
exports.Notification = (0, helpers_1.createUIElement)('Notification', (_a, ref) => {
    var { className, status = types_1.NOTIFICATION_STATUS.info, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "status", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StyledStackView, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'notification-wrapper', className: `vm-Notification ${className}`, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.start, "data-status": exports.NOTIFICATION_STATUSES[status], onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        status === types_1.NOTIFICATION_STATUS.loading ? (react_1.default.createElement(Spinner_1.Spinner, { "data-selector-id": "notification-spinner", size: 16 })) : (react_1.default.createElement(Icon_1.Icon, { "data-selector-id": "notification-icon", size: Icon_1.ICON_SIZES.m, src: (0, exports.getIconSrc)(status) })),
        react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, spaceFill: View_1.SPACE_FILL.all },
            react_1.default.createElement(Text_1.Text, { "data-selector-id": "notification-text" }, children))));
});
//# sourceMappingURL=Notification.js.map